import React, { useState } from 'react';
import { Heart, CreditCard, ExternalLink, ShieldCheck, Gift } from 'lucide-react';
const PRESET_AMOUNTS = [100, 200, 500, 1000];
export function DonationCard() {
  const [selectedPreset, setSelectedPreset] = useState<number | null>(null);
  const [inputAmount, setInputAmount] = useState<string>('');
  const [comment, setComment] = useState<string>('');
  const handlePresetClick = (value: number) => {
    setSelectedPreset(value);
    setInputAmount(String(value));
  };
  const handleCustomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, '');
    setInputAmount(value);
    const num = parseInt(value);
    setSelectedPreset(PRESET_AMOUNTS.includes(num) ? num : null);
  };
  const currentAmount = parseInt(inputAmount) || 0;
  return <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_4px_24px_rgba(0,0,0,0.04)] border border-slate-100 border-l-4" style={{
    borderLeftColor: '#fb7185'
  }} data-id="element-138">
      <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-139">
        {/* Left: Info & Icon */}
        <div className="flex-1" data-id="element-140">
          <div className="flex items-center gap-3 mb-4" data-id="element-141">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{
            backgroundColor: '#fff1f2'
          }} data-id="element-142">
              <Heart className="w-6 h-6" style={{
              color: '#e11d48'
            }} data-id="element-143" />
            </div>
            <div data-id="element-144">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-145">
                Підтримати федерацію
              </h3>
              <p className="text-sm text-slate-500" data-id="element-146">
                Добровільний внесок · не впливає на статус членства
              </p>
            </div>
          </div>

          <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-147">
            Ваш добровільний внесок допомагає розвивати альпінізм та
            скелелазіння в Україні — організовувати змагання, навчальні програми
            та підтримувати спортсменів. Кожна гривня важлива!
          </p>

          <div className="flex items-center gap-2 text-sm text-slate-500 bg-slate-50 p-3 rounded-lg border border-slate-100 w-fit" data-id="element-148">
            <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-149" />
            <span data-id="element-150">Всі внески офіційні та прозорі</span>
          </div>
        </div>

        {/* Right: Payment Form */}
        <div className="w-full md:w-[400px] flex-shrink-0 bg-slate-50 rounded-xl p-6 border border-slate-100" data-id="element-151">
          <label className="block text-sm font-semibold text-slate-700 mb-3" data-id="element-152">
            Оберіть або введіть суму
          </label>

          {/* Presets */}
          <div className="grid grid-cols-4 gap-2 mb-4" data-id="element-153">
            {PRESET_AMOUNTS.map(preset => <button key={preset} onClick={() => handlePresetClick(preset)} className={`py-2.5 px-1 rounded-lg text-sm font-semibold transition-all border ${selectedPreset === preset ? 'text-white border-rose-600 shadow-sm' : 'bg-white text-slate-600 border-slate-200 hover:border-rose-300 hover:text-rose-600'}`} style={selectedPreset === preset ? {
            background: 'linear-gradient(135deg, #e11d48, #be123c)',
            borderColor: '#be123c'
          } : {}} data-id="element-154">
                ₴{preset}
              </button>)}
          </div>

          {/* Custom Amount Input */}
          <div className="relative mb-4" data-id="element-155">
            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 font-medium" data-id="element-156">
              ₴
            </span>
            <input type="text" inputMode="numeric" value={inputAmount} onChange={handleCustomChange} placeholder="Інша сума" className="w-full pl-8 pr-4 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-400 transition-all text-slate-900 font-medium placeholder:text-slate-400 bg-white" data-id="element-157" />
          </div>

          {/* Optional comment */}
          <div className="mb-5" data-id="element-158">
            <label className="block text-xs font-medium text-slate-500 mb-1.5" data-id="element-159">
              Коментар <span className="text-slate-400" data-id="element-160">(необов'язково)</span>
            </label>
            <input type="text" value={comment} onChange={e => setComment(e.target.value)} placeholder="Наприклад: на організацію чемпіонату" className="w-full px-3 py-2.5 rounded-xl border border-slate-200 focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-400 transition-all text-sm text-slate-700 placeholder:text-slate-400 bg-white" data-id="element-161" />
          </div>

          {/* Pay Button */}
          <button disabled={!currentAmount} className="w-full flex items-center justify-center gap-2 py-3.5 px-4 rounded-xl text-white font-semibold text-sm transition-all hover:opacity-90 active:scale-[0.98] disabled:opacity-40 disabled:cursor-not-allowed" style={{
          background: 'linear-gradient(135deg, #e11d48, #be123c)',
          boxShadow: currentAmount ? '0 4px 14px rgba(225,29,72,0.30)' : 'none'
        }} data-id="element-162">
            <Heart className="w-4 h-4" data-id="element-163" />
            {currentAmount > 0 ? `Підтримати ₴${currentAmount}` : 'Підтримати через LiqPay'}
            <ExternalLink className="w-3.5 h-3.5 opacity-70" data-id="element-164" />
          </button>

          <div className="flex items-center justify-center gap-1.5 mt-3" data-id="element-165">
            <ShieldCheck className="w-3.5 h-3.5 text-slate-400" data-id="element-166" />
            <p className="text-xs text-slate-400" data-id="element-167">
              Безпечна оплата через LiqPay
            </p>
          </div>
        </div>
      </div>
    </div>;
}